import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import './gtm-event-login';

@Injectable({
    providedIn: 'root'
})
export class GtmEventLoginTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * Customer model service
     */
    private customerModel = inject(CustomerModel);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Timeout service
     */
    private timoutService = inject(TimeoutService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'nexusCheckoutLogin' || event.id === 'nexusCustomerLogin') {
                this.timoutService.setTimeout(() => {
                    if (this.customerModel.isLoggedIn) {
                        this.dispatch(event);
                    }
                }, 100);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData) {
        const data = this.customerModel.data;
        return this.gtmService.dispatch({
            event: 'login',
            triggerContext: {
                trigger
            },
            customer_email: data.email,
            customer_id: data.id
        });
    }
}
